<template>
  <div class="wish_action">
    <div class="tip">
      <span v-if="$store.getters['User/user'].appUser.fileWish ||
          $store.getters['User/user'].appUser.musicWish ||
          $store.getters['User/user'].appUser.photoWish ||
          $store.getters['User/user'].appUser.videoWish">还有<span
          style="color: #fb5946">{{ $store.getters["User/user"].appUser.wishCount }}</span>次抽福利机会</span>
      <span v-else>完成任务可获取机会</span>
    </div>
    <wd-img @click="wish" class="png_make_wish_btn" :src="makeWishBtn"/>
    <wd-popup v-model="showSucceed"
              class="wish-popup"
              :close-on-click-modal="false"
              @close="showSucceed = false"
              closable
    >
      <div class="lotto-popup-content bg-all pa-lg round-16 mt-xxxl" style="margin-top: 80px">
        <div class="mb-lg wish-alter" style="margin: -120px 0 0 -190px;">
          <wd-img width="160" :src="wishAlter"/>
        </div>
        <div class="lotto-popup-content--title"></div>
        <div style="font-size: 24px;color: orangered" class="text-bold mb-lg wish-text">
          恭喜你获得
        </div>
        <div style="font-size: 24px;color: orangered;" class="mb-xxl wish-text">
          {{ exchangeData.prize.name }}
        </div>
        <div style="margin: 0 40px">
          <wd-button type="error" block class="mb-xxxl wish-btn" @click="toDetil">查看详情</wd-button>
        </div>
        <div class="upload-end-img">
          <wd-img width="140" :src="boxEnd"/>
        </div>
      </div>
    </wd-popup>
    <wd-popup v-model="showFail"
              class="wish-popup"
              :close-on-click-modal="false"
              @close="showFail = false"
              closable
    >
      <div class="lotto-popup-content bg-all pa-lg round-16 mt-xxxl" style="margin-top: 80px">
        <div class="mb-lg wish-alter" style="margin: -120px 0 0 -190px;">
          <wd-img width="160" :src="wishAlter"/>
        </div>
        <div class="lotto-popup-content--title"></div>
        <div style="font-size: 18px;color: orangered;margin-top: -24px" class="mb-md wish-text">
          很遗憾
        </div>
        <div style="font-size: 24px;color: orangered" class="text-bold wish-text">
          没有获得奖品
        </div>
        <div style="font-size: 18px;color: orangered;" class="mb-xl mt-md wish-text">
          还有{{ ' ' + $store.getters["User/user"].appUser.wishCount + ' ' }}次福利机会
        </div>
        <div style="margin: 0 40px">
          <wd-button type="error" block class="mb-xxxl wish-btn" @click="wish">再来一次</wd-button>
        </div>
        <div class="upload-end-img">
          <wd-img width="140" :src="boxEnd"/>
        </div>
      </div>
    </wd-popup>
    <wd-popup v-model="showLoading"
              :close-on-click-modal="false"
              class="round-16 pa-lg" style="background-color: transparent">
      <wd-loading style="margin: 16px auto;"></wd-loading>
      <span style="color: white">抽奖中...</span>
    </wd-popup>
  </div>
</template>

<script>
import {exchange} from "@/api/tianyi/tianyi.api";
import {makeWishBtn,wishAlter,boxEnd} from "@/skin/skin";

export default {
  name: "WishAction",
  data() {
    return {
      makeWishBtn:makeWishBtn,
      wishAlter:wishAlter,
      boxEnd:boxEnd,
      showSucceed: false,
      showFail: false,
      showLoading: false,
      exchangeData: {
        prize: {
          name: ''
        }
      }
    }
  },
  methods: {
    toDetil() {
      this.$router.push("/prize")
    },
    wish() {
      this.showFail = false
      this.showSucceed = false
      if (this.$store.getters["User/user"].appUser.wishCount === 0) {
        if (this.$store.getters['User/user'].appUser.fileWish ||
            this.$store.getters['User/user'].appUser.musicWish ||
            this.$store.getters['User/user'].appUser.photoWish ||
            this.$store.getters['User/user'].appUser.videoWish) {
          this.$toast.warning('您的机会已用完')
        } else {
          this.$toast.warning('请完成任务获取机会')
        }
        return false
      }
      this.showLoading = true
      const _this = this
      setTimeout(() => {
        exchange(_this.$store.getters["User/user"].appUser.token).then(resp => {
          _this.showLoading = false
          if (resp.code === 0) {
            _this.$store.dispatch("User/getUploadDetails", _this.$store.getters["User/user"].appUser.token).then(res => {
              _this.exchangeData = resp.data
              if (_this.exchangeData.prize.name === '谢谢参与') {
                _this.showFail = true
              } else {
                _this.showSucceed = true
              }
            })
          } else {
            _this.$toast.error(resp.msg)
          }
        })
      }, 600)

    }
  }
}
</script>

<style lang="scss">
.wish-popup {
  width: 360px;
  background-color: transparent;

  .wd-popup__close {
    right: 64px;
    top: 96px;
    font-size: 16px;
  }

  .lotto-popup-content {
    margin: 48px 48px 120px 48px;
    text-align: center;
  }

  .upload-end-img {
    div {
      margin-right: -190px;
      margin-bottom: -40px;
      margin-top: -80px;
    }
  }
}

.wish_action {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -24px;

  .png_make_wish_btn {
    width: 220px;
    margin-right: -16px;
  }

  .tip {
    width: 180px;
    background-color: #fff;
    padding: 2px 0 2px 8px;
    border-radius: 16px;
    position: relative;
    border: 1px solid #f49d9d;
    margin-bottom: 0.5rem;
    letter-spacing: 3px;
    font-weight: bold;
    font-size: 14px;
    color: #943729;

    &::before {
      box-sizing: content-box;
      position: absolute;
      top: 24px;
      right: 86px;
      border-top: 9px solid snow;
      border-bottom: 9px solid transparent;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      display: block;
      content: '';
      z-index: 2;
    }

    &::after {
      box-sizing: content-box;
      position: absolute;
      top: 24px;
      right: 85px;
      border-top: 10px solid #f49d9d;
      border-bottom: 10px solid transparent;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      display: block;
      content: '';
      z-index: 1

    }
  }

}
</style>
